<template>
  <div class="app-body">
    <OrderDetailTable></OrderDetailTable>
  </div>
</template>

<script>
import OrderDetailTable from '@/components/OrderDetailTable.vue'

export default {
  name: 'order-detail-manager',
  mixins: [],
  components: { OrderDetailTable },
  data () {
    return {}
  },
  methods: {
  },
}
</script>
